<div *ngIf="disclaimerVisible()" class="acquisition-disclaimer">
  <p>{{ disclaimerMessage() }}</p>
</div>
